import { getBrowserApiBase } from "./browser-api-base";
import { getAccessToken } from "./supabase";

export interface ManualSupportTicketInput {
  title: string;
  descriptionMarkdown: string;
  issueType?: "bug" | "feature" | "question" | "support" | "regression";
  severity?: "low" | "medium" | "high" | "critical";
  appVersion?: string;
  surface?: string;
  url?: string;
  userAgent?: string;
}

export interface ManualSupportTicketResult {
  issue: {
    identifier: string;
    title: string;
    url: string;
    stateName: string;
  };
}

export async function submitManualSupportTicket(
  input: ManualSupportTicketInput,
): Promise<ManualSupportTicketResult> {
  const token = await getAccessToken();
  const response = await fetch(
    `${getBrowserApiBase()}/api/support/tickets/manual`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(input),
    },
  );
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.ok) {
    throw new Error(
      typeof data?.error === "string"
        ? data.error
        : "Support ticket could not be filed.",
    );
  }
  return { issue: data.issue };
}
